import { languageNames } from "../i18n/LanguageList";
import { decryptData } from "../utils/jsUtils";

export const getLocalDateTime = dateInMillis => {
  let date = new Date(dateInMillis);
  let dateTimeString = date.toLocaleString(window.navigator.language);
  let [localDate, localTime] = dateTimeString.split(",");
  return localDate + " " + localTime;
};

export function getDate(dateObj) {
  let date = new Date(dateObj);
  return (
    [
      date.toLocaleDateString(window.navigator.language)
    ].join("/") +
    " " +
    [
      (date.getHours() < 10 ? "0" : "") + date.getHours(),
      (date.getMinutes() < 10 ? "0" : "") + date.getMinutes(),
      (date.getSeconds() < 10 ? "0" : "") + date.getSeconds()
    ].join(":")
  );
}

export const getYYMMDD = dateObj => {
  let date = new Date(dateObj);
  let month = date.getMonth() + 1;
  let curDate = date.getDate();
  return [
    date.getFullYear(),
    (month < 10 ? "0" : "") + month,
    (curDate < 10 ? "0" : "") + curDate
  ].join("/");
};

export const getMMDDYY = dateObj => {
  let date = new Date(dateObj);
  let month = date.getMonth() + 1;
  let curDate = date.getDate();
  return [
    (month < 10 ? "0" : "") + month,
    (curDate < 10 ? "0" : "") + curDate,
    date.getFullYear()
  ].join("/");
};

export const getDDMMYY = dateObj => {
  let date = new Date(dateObj);
  let month = date.getMonth() + 1;
  let curDate = date.getDate();
  return [
    (curDate < 10 ? "0" : "") + curDate,
    (month < 10 ? "0" : "") + month,
    date.getFullYear()
  ].join("/");
};

export const getHHMM = dateObj => {
  let date = new Date(dateObj);
  return [
    (date.getHours() < 10 ? "0" : "") + date.getHours(),
    (date.getMinutes() < 10 ? "0" : "") + date.getMinutes()
  ].join(":");
};

export const getAMPM = dateObj => {
  let date = new Date(dateObj);
  let month = date.getMonth() + 1;
  let curDate = date.getDate();
  let hours = date.getHours();
  let period = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  if (!hours) hours = 12;
  return (
    [
      date.toLocaleDateString(window.navigator.language)
    ].join("/") +
    " " +
    [
      (hours < 10 ? "0" : "") + hours,
      (date.getMinutes() < 10 ? "0" : "") + date.getMinutes(),
      (date.getSeconds() < 10 ? "0" : "") + date.getSeconds()
    ].join(":") +
    " " +
    period
  );
};

export const getDashboardRecentItemDisplayTime = dateObj => {
  const actualTimeMilliseconds = new Date().getTime();
  let date = new Date(dateObj);
  let timeDiff = actualTimeMilliseconds - dateObj;
  if (timeDiff > 86400000) {
    let hours = date.getHours();
    let period = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    if (!hours) hours = 12;
    return (
      [
        (hours < 10 ? "0" : "") + hours,
        (date.getMinutes() < 10 ? "0" : "") + date.getMinutes()
      ].join(":") +
      " " +
      period +
      "  " +
      [
        date.toLocaleDateString(window.navigator.language)
      ].join("/")
    );
  } else {
    var diffSecs = timeDiff / 1000;
    if (diffSecs < 60) return Math.round(diffSecs) + " " + "Seconds ago";
    else if (diffSecs / 60 < 60)
      return Math.round(diffSecs / 60) + " " + "Minutes ago";
    else if (diffSecs / 3600 < 24)
      return Math.round(diffSecs / 3600) + " " + "Hrs ago";
  }
};

export function addHypen(str) {
  let result = '';
  if( str.includes('419')) return 'es-419';
  if(str.includes('-')) return str;
  for (let i = 0; i < str.length; i++) {
    if (str[i] === str[i].toUpperCase() && i > 0) {
      result += '-' + str[i].toLowerCase(); 
    } else {
      result += str[i]; 
    }
  }
  return result;
}

export const getLocale = (pathname, includeSlash) => {
  let locale = pathname.split("/").filter(x => x !== "")[0];
  locale = locale?.length > 2 ? addHypen(locale) : locale;
  let keyNames = Object.keys(languageNames);
  let isLocaleExists = keyNames.filter(x => x === locale);
  let localeName = isLocaleExists.length
    ? includeSlash
      ? "/" + locale
      : locale
    : includeSlash
    ? "/en"
    : "en";
  return localeName;
};

export const millisecToDate = date => {
  return new Date(date).toISOString();
};

export const DateToMillisec = dte => {
  return new Date(dte).getTime();
};

export const UTCtoEpoc = dt => {
  let epocDate = new Date(dt).getTime();
  return epocDate;
};

export const convertTime12to24 = time12h => {
  const [time, modifier] = time12h.split(" ");

  let [hours, minutes] = time.split(":");

  if (hours === "12") {
    hours = "00";
  }

  if (modifier === "PM") {
    hours = parseInt(hours, 10) + 12;
  }

  return hours + ":" + minutes + ":00";
};

export const convertTime24to12 = time => {
  time = time.toString().split(":");
  let hours = time[0];
  let AmOrPm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  let minutes = time[1] >= 30 ? 30 : "00";
  let finalTime = hours + ":" + minutes + " " + AmOrPm;
  return finalTime;
};

export const convertTime24to12new = time => {
  time = time.toString().split(":");
  let hours = time[0];
  let AmOrPm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  let minutes = time[1];
  let seconds = time[2];
  let finalTime = hours + ":" + minutes + ":" + seconds + " " + AmOrPm;
  return finalTime;
};

export const isEmptyObj = obj => {
  return Object.getOwnPropertyNames(obj).length === 0 || obj.length === 0;
};

export const getFeatureToggle = key => {
  const featuresToggles = decryptData(localStorage.getItem("featuresToggles"));
  if (!featuresToggles) {
    return [];
  }
  let featureList = JSON.parse(featuresToggles)
    ? JSON.parse(featuresToggles)
    : null;
  let featureRequestObj = {};
  if (featureList) {
    featureRequestObj = featureList.length
      ? featureList.filter(item => item.feature === key)
      : [];
  }
  return featureRequestObj;
};

export const lazyRetry = function(componentImport) {
  return new Promise((resolve, reject) => {
      // check if the window has already been refreshed
      const hasRefreshed = JSON.parse(
          window.sessionStorage.getItem('retry-lazy-refreshed') || 'false'
      );
      // try to import the component
      componentImport().then((component) => {
          window.sessionStorage.setItem('retry-lazy-refreshed', 'false'); // success so reset the refresh
          resolve(component);
      }).catch((error) => {
          if (!hasRefreshed) { // not been refreshed yet
              window.sessionStorage.setItem('retry-lazy-refreshed', 'true'); // we are now going to refresh
              return window.location.reload(); // refresh the page
          }
          reject(error); // Default error behaviour as already tried refresh
      });
  });
};
